import { inject } from '@angular/core';
import { CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { ProductType } from '@core/contracts/data-contracts';
import { AppRouting } from '@core/enums';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import { map, take } from 'rxjs';

export const internetRestrictionGuard: CanMatchFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(userFeature.selectActiveProduct)
    .pipe(
      take(1),
      map((activeProduct) => {
        return activeProduct !== ProductType.Internet
          ? true
          : new RedirectCommand(router.parseUrl(`/${AppRouting.Overview}`))
      })
    );
};
